import {api} from "./api.ts";
import {validCalculation} from "./measurementDraft.ts";
import type {CalculationRequest} from "./types";

const pendingKey="nord-pending-calculation-pdf";
const reloadKey="nord-calculation-pdf-reload";
export async function exportCalculationPdf(request:CalculationRequest,actor:string){
 const result=await api.exportCalculation(request);
 try{
  const {downloadCalculationPdf}=await import("./calculationPdf");
  await downloadCalculationPdf(result,request);
  sessionStorage.removeItem(pendingKey);sessionStorage.removeItem(reloadKey);
 }catch(reason){
  // A deploy can remove a lazy chunk referenced by an already-open page. Keep
  // only this actor's pending request, refresh once, then use the new bundle.
  if(reason instanceof Error&&/Failed to fetch dynamically imported module|Importing a module script failed/.test(reason.message)
    && Date.now()-Number(sessionStorage.getItem(reloadKey)??0)>60000){
   sessionStorage.setItem(pendingKey,JSON.stringify({actor,request,createdAt:Date.now()}));
   sessionStorage.setItem(reloadKey,String(Date.now()));window.location.reload();return;
  }
  throw reason;
 }
}
export function takePendingCalculationPdf(actor:string):CalculationRequest|null{
 try{
  const raw=sessionStorage.getItem(pendingKey);if(!raw)return null;
  const saved=JSON.parse(raw);
  if(saved.actor!==actor)return null;
  sessionStorage.removeItem(pendingKey);
  return Date.now()-saved.createdAt<180000&&validCalculation(saved.request)?saved.request:null;
 }catch{sessionStorage.removeItem(pendingKey);return null;}
}
